export const calculatePouleRanking = (matches, athletes) => {
    const stats = {};

    // Initialiser les stats pour chaque athlète de la catégorie
    athletes.forEach(a => {
        stats[a.id] = {
            athlete: a,
            points: 0,
            victories: 0,
            defeats: 0,
            played: 0
        };
    });

    matches.forEach(m => {
        if (m.winner_id) {
            const id1 = String(m.athlete1_id);
            const id2 = String(m.athlete2_id);
            const winnerId = String(m.winner_id);

            // On s'assure que les athlètes existent dans nos stats
            if (stats[id1] && stats[id2]) {
                stats[id1].played++;
                stats[id2].played++;

                if (winnerId === id1) {
                    stats[id1].points += 3; // Victoire
                    stats[id1].victories++;
                    stats[id2].points += 1; // Défaite
                    stats[id2].defeats++;
                } else {
                    stats[id2].points += 3; // Victoire
                    stats[id2].victories++;
                    stats[id1].points += 1; // Défaite
                    stats[id1].defeats++;
                }
            }
        }
    });

    // Trier par points, puis par nombre de victoires en cas d'égalité
    return Object.values(stats).sort((a, b) => {
        if (b.points !== a.points) return b.points - a.points;
        return b.victories - a.victories;
    });
};